"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.portalType = exports.portalLabel = exports.isSupplierPortal = void 0;
// +----------------------------------------------------------------------
// | 商户 / 供应商管理端门户标识（由构建环境变量区分）
// +----------------------------------------------------------------------

var portalType = exports.portalType = String(process.env.VUE_APP_PORTAL_TYPE || 'merchant').toLowerCase();
var isSupplierPortal = exports.isSupplierPortal = portalType === 'supplier';
var portalLabel = exports.portalLabel = process.env.VUE_APP_PORTAL_LABEL || (isSupplierPortal ? '供应商' : '商户');